import {
  CART_ADD_ITEM,
  CART_REMOVE_ITEM,
  CART_SAVE_PAYMENT_METHOD,
  CART_SAVE_SHIPPING_ADDRESS,
} from "../Constants/CartConstants";
import URL from "../Url";

// ✅ ADD TO CART
export const addToCart = (id, qty) => async (dispatch, getState) => {
  const res = await fetch(`${URL}/api/products/${id}`);
  const data = await res.json();

  const image =
    Array.isArray(data.images) && data.images.length > 0
      ? data.images[0]
      : data.image || "fallback.jpg";

  const price =
    data.onSale && data.salePrice && data.salePrice > 0
      ? parseFloat(data.salePrice)
      : parseFloat(data.price);

  dispatch({
    type: CART_ADD_ITEM,
    payload: {
      product: data._id,
      name: data.name,
      dimensions: data.dimensions,
      image,
      price,
      salePrice: data.salePrice || 0,
      onSale: data.onSale || false,
      countInStock: data.countInStock,
      qty,
    },
  });

  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};

// ✅ REMOVE PRODUCT
export const removefromcart = (id) => (dispatch, getState) => {
  dispatch({
    type: CART_REMOVE_ITEM,
    payload: id,
  });
  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};

// ✅ SAVE SHIPPING
export const saveShippingAddress = (data) => (dispatch) => {
  dispatch({ type: CART_SAVE_SHIPPING_ADDRESS, payload: data });
  localStorage.setItem("shippingAddress", JSON.stringify(data));
};

// ✅ SAVE PAYMENT
export const savePaymentMethod = (data) => (dispatch) => {
  dispatch({ type: CART_SAVE_PAYMENT_METHOD, payload: data });
  localStorage.setItem("paymentMethod", JSON.stringify(data));
};